import type { IconType } from "react-icons";
import { IoIosPeople, IoMdHome } from "react-icons/io";
import {
  MdHelp,
  MdHelpOutline,
  MdNewReleases,
  MdOutlineNewReleases,
  MdOutlineReceipt,
  MdOutlineSettings,
  MdReceipt,
  MdSettings,
  MdOutlineAccountBalance
} from "react-icons/md";
import { VscHome } from "react-icons/vsc";
import { GrTransaction } from "react-icons/gr";

export const LAYOUT_PADDING = 16;

export const LAYOUT_BREAKPOINT_WIDTH = 750;
export const SECONDARY_BUTTON_BREAKPOINT_WIDTH = 950;
export const PRIMARY_BUTTON_BREAKPOINT_WIDTH = 1100;

export type SideBarDataSourcesProps = {
  path: string;
  name: string;
  icons: IconType;
  selectedIcons: IconType;
  activePath: string;
};
export const SIDEBAR_DATASOURCE: SideBarDataSourcesProps[] = [
  {
    path: "/home",
    name: "Home",
    icons: VscHome,
    selectedIcons: IoMdHome,
    activePath: "/home",
  },
  {
    path: "/users",
    name: "Users",
    icons: IoIosPeople,
    selectedIcons: IoIosPeople,
    activePath: "/users",
  },
  {
    path: "/applications",
    name: "Applications",
    icons: MdOutlineReceipt,
    selectedIcons: MdReceipt,
    activePath: "/applications",
  },
  {
    path: "/accounts",
    name: "Accounts",
    icons: MdOutlineAccountBalance,
    selectedIcons: MdOutlineAccountBalance,
    activePath: "/accounts",
  },
  {
    path: "/transactions",
    name: "Transactions",
    icons: GrTransaction,
    selectedIcons: GrTransaction,
    activePath: "/transactions",
  },
];

export const SCROLLBAR_STYLE = `  ::-webkit-scrollbar {
    visibility: hidden;
    width: 6px;
    height:6px;
  }
  -ms-overflow-style: none;
  scrollbar-width: none;

  :hover {
    ::-webkit-scrollbar {
      display: block;
      
    }

    ::-webkit-scrollbar-track {
      background-color: transparent;
    }

    ::-webkit-scrollbar-thumb {
      background-color: #888;
      border-radius: 8px;
    }
    scrollbar-width: thin;
    scrollbar-track-color: transparent;
    scrollbar-thumb-color: #b3b3b3;`;

export const SIDEBAR_FOOTER_DATASOURCE: SideBarDataSourcesProps[] = [
  // {
  //   path: "/whats-new",
  //   name: "whatsNew",
  //   icons: MdOutlineNewReleases,
  //   selectedIcons: MdNewReleases,
  //   activePath: "/whats-new",
  // },
  {
    path: "/help",
    name: "help",
    icons: MdHelpOutline,
    selectedIcons: MdHelp,
    activePath: "/help",
  },
  {
    path: "/settings",
    name: "settings",
    icons: MdOutlineSettings,
    selectedIcons: MdSettings,
    activePath: "/settings",
  },
];
